import { useSmartAudiences } from "@/services/smartAudience/hooks";
import { CustomLink } from "@/styles/shared/link/link.style";
import { Button, Card, Menu, Skeleton, Stack, Text, Title } from "@mantine/core";
import { IconChevronLeft, IconSparkles } from "@tabler/icons-react";
import { useState } from "react";
import { audienceAction, audiencePath, audienceTitle, lastSentNote } from "./text";

const FIRST = 3;

// «پیشنهادهای امروز» on the marketing page: the server's ready-made audiences, most important first.
// Hidden where the API is missing or there is nothing to suggest.
export default function TodaySuggestions() {
  const audiences = useSmartAudiences();
  const [all, setAll] = useState(false);
  if (audiences.isError || (audiences.isSuccess && !audiences.data.length)) return null;
  const items = audiences.data ?? [];
  const shown = all ? items : items.slice(0, FIRST);
  return (
    <Stack gap="md" mb="xl">
      <Title order={4}>پیشنهادهای امروز</Title>
      <Card withBorder>
        {audiences.isLoading ? (
          <Stack gap="sm">
            <Skeleton height={44} />
            <Skeleton height={44} />
          </Stack>
        ) : (
          <Menu>
            {shown.map((audience) => (
              <CustomLink key={audience.key} to={audiencePath(audience.key ?? "")}>
                <Menu.Item
                  py="sm"
                  leftSection={<IconSparkles size={20} stroke={1.5} color="var(--mantine-color-violet-6)" />}
                  rightSection={<IconChevronLeft size={20} stroke={1} />}
                >
                  <Text fw={500}>{audienceTitle(audience)}</Text>
                  <Text size="xs" c="dimmed">
                    {lastSentNote(audience.lastSentAt) ?? audienceAction(audience.kind)}
                  </Text>
                </Menu.Item>
              </CustomLink>
            ))}
            {items.length > FIRST && (
              <Button variant="subtle" color="violet" fullWidth mt="xs" onClick={() => setAll((value) => !value)}>
                {all ? "نمایش کمتر" : `همه‌ی پیشنهادها (${items.length.toLocaleString("fa-IR")})`}
              </Button>
            )}
          </Menu>
        )}
      </Card>
    </Stack>
  );
}
